/**
 * 从 CSD/旧版存储格式中提取真实 token。
 * 空认证态经常长成 {"token":null,"userInfo":null}，不能把整段 JSON 当 token 使用。
 */
export function extractStoredAuthToken(value: unknown, depth = 0): string {
  if (depth > 4 || value == null) return ''

  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (!trimmed) return ''

    try {
      const parsed = JSON.parse(trimmed)
      const parsedToken = extractStoredAuthToken(parsed, depth + 1)
      if (parsedToken) return parsedToken
      if (trimmed.startsWith('{') || trimmed.startsWith('[')) return ''
    } catch {
      if (trimmed.startsWith('{') || trimmed.startsWith('[')) return ''
    }

    return trimmed
  }

  if (typeof value !== 'object') return ''

  const data = value as { token?: unknown; value?: unknown }
  const token = typeof data.token === 'string' ? data.token.trim() : ''
  if (token) return token

  return extractStoredAuthToken(data.value, depth + 1)
}
